import React__default from 'react';
import { Box } from '@mui/material';
import clsx from 'clsx';

/**
 * Player 3D including the kpk-3d web component
 * @param src original media url
 * @param id viewer id (make it different per media to force the reload)
 */
var Player3DViewer = function (_a) {
    var src = _a.src, id = _a.id;
    if (!src) {
        return null;
    }
    if (src.endsWith(".usdz")) {
        src = src.replace(".usdz", ".glb");
    }
    return (React__default.createElement(Box, { className: clsx("Player3DViewer"), sx: function () { return ({
            height: "100%",
            width: "100%"
        }); } },
        React__default.createElement("kpk-3d", { "data-testid": "kpk-3d", className: clsx("player3d"), src: src, key: id })));
};

export { Player3DViewer as default };
//# sourceMappingURL=index.js.map
